export default __webpack_public_path__ + "static/media/043-skis.db20000a.svg";